export const setSecurityProviderSnippet =
`nca.ds.core:
  device-info-decryption:
    keystore-type: CloudHSM
    keystore-provider: CloudHSM
    key-encryption-provider: CloudHSM`

export const enableAndConfigureSnippet =
`nca.ds.aws.cloudhsm:
  enabled: true
  username: cloudHSM-username
  password: cloudHSM-password
  config-path: /path/to/cloudhsm-jce.json`

export const cloudHsmSdkConfigFileSnippet =
`{
  "clusters": [
    {
      "type": "hsm1",
      "cluster": {
        "hsm_ca_file": "/workdir/config/certs/customerCA.crt",
        "servers": [
          {
            "hostname": "1.2.3.4",
            "port": 2223,
            "enable": true
          }
        ],
        "options": {
          "disable_key_availability_check": true,
          "validate_key_at_init": false
        }
      }
    }
  ],
  "logging": {
    "log_type": "term",
    "log_level": "info"
  }
}`

export const genRsaKeySnippet = `genRSAKeyPair -m 2048 -e 65537 -l 3ds-ds-device-info-encryption-key`

export const setLabelSnippet = `setAttribute -o <key_handle> -a 3`

export const getLabelSnippet = `getAttribute -o <key_handle> -a 3`
